<template>
  <div>
    <v-card id="card" class="card-text rounded-0" color="" style="">
      <div :class="[rowClasses(item), 'px-1']">
        <v-row>
          <v-col class="my-auto py-0">
            <v-row>
              <v-col cols="8">
                <v-row>
                  <v-col class="">
                    {{ item.EnterDayName }}
                  </v-col>
                  <v-col class="">{{ item.BeginDate }}</v-col>
                </v-row>
                <v-row class="py-0 my-0">
                  <v-col>
                    <div class="text-caption text-caption-color">
                      <span class="font-sahel">
                        ( {{ $t("DurationTime") }} :
                        <span
                          :class="
                            item.Duration == '۰۰۰:۰۰' ? 'error--text' : ''
                          "
                          >{{ item.Duration }}</span
                        >
                        )</span
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col
                cols="4"
                style="
                  justify-content: left;
                  align-content: center;
                  display: flex;
                "
              >
              </v-col>
            </v-row>
          </v-col>
          <v-col class="my-auto py-0" cols="auto">
            <v-btn icon @click="showContextMenu($event, item)">
              <v-icon>mdi-dots-vertical</v-icon></v-btn
            >
            <v-btn icon @click="show = !show" class="card-text">
              <v-icon>{{
                show ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-expand-transition class="">
          <div v-show="show" class="py-1">
            <v-row>
              <v-col>
                <v-row>
                  <v-col cols="6" class="my-auto py-0"
                    >{{ $t("EntryTime") }} :
                    <span class="text-value">{{ item.BeginTime }}</span>
                  </v-col>
                  <v-col cols="6" class="my-auto py-0"
                    >{{ $t("ExitTime") }} :
                    <span class="text-value">{{ item.EndTime }}</span>
                  </v-col>
                  <v-col cols="6" class="my-auto py-0"
                    >{{ $t("ExitDate") }} :
                    <span class="text-value">{{ item.EndDate }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="auto py-0">
                <div style="width: 36px; height: 36px"></div>
              </v-col>
            </v-row>
          </div>
        </v-expand-transition>
      </div>
    </v-card>
    <IOContextMenu ref="IOContextMenu" :x="x" :y="y" />
  </div>
</template>

<script>
import IOContextMenu from "../../widget/IOContextMenu.vue";
export default {
  props: {
    item: Object,
  },
  computed: {},
  data() {
    return {
      show: false,
      x: 0,
      y: 0,
    };
  },
  methods: {
    rowClasses(item) {
      if (item.DMP == 1) {
        return "bg-green";
      }
    },
    showContextMenu(e, item) {
      this.$refs.IOContextMenu.hideMenu();
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.$refs.IOContextMenu.showMenu(item);
      });
    },
  },
  components: { IOContextMenu },
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>